var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import UrlTraits from "./UrlTraits";
import { traitClass } from "../Trait";
let OpenStreetMapCatalogItemTraits = (_dec = traitClass({
  description: "Creates one base map item from url that points to an OpenStreetMap service.",
  example: {
    item: {
      type: "open-street-map",
      name: "Voyager",
      url: "https://global.ssl.fastly.net/rastertiles/voyager/",
      attribution: "© OpenStreetMap contributors ODbL, © CartoDB CC-BY 3.0",
      opacity: 1,
      subdomains: ["cartodb-basemaps-a", "cartodb-basemaps-b", "cartodb-basemaps-c", "cartodb-basemaps-d"]
    },
    image: "https://terria-catalogs-public.storage.googleapis.com/misc/basemaps/icons/voyager-aus.png",
    id: "some unique id"
  }
}), _dec2 = primitiveTrait({
  name: "File extension",
  description: "The file extension used to retrieve Open Street Map data",
  type: "string"
}), _dec3 = primitiveArrayTrait({
  name: "Subdomains",
  description: "Array of subdomains, one of which will be prepended to each tile URL. This is useful for overcoming browser limit on the number of simultaneous requests per host.",
  type: "string"
}), _dec(_class = (_class2 = class OpenStreetMapCatalogItemTraits extends mixTraits(ImageryProviderTraits, LayerOrderingTraits, UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "fileExtension", _descriptor, this);
    _initializerDefineProperty(this, "subdomains", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "fileExtension", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "png";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "subdomains", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class2)) || _class);
export { OpenStreetMapCatalogItemTraits as default };